module.exports = __webpack_public_path__ + "static/media/printer-debugging.275ad344.jpeg";